/*
 * Public API Surface of angular-gradient-progressbar
 */


export * from './lib/angular-gradient-progressbar.component';
export * from './lib/angular-gradient-progressbar.module';
